import { ConceptFlowLinkPoint } from "@/app/types/illustrations/ConceptFlowLink";

export const CONCEPT_FLOW_VIRTUAL_WIDTH = 100;

function round(value: number): number {
  return Math.round(value * 2) / 2;
}

function roundPoint(point: ConceptFlowLinkPoint): ConceptFlowLinkPoint {
  return { x: round(point.x), y: round(point.y) };
}

function bendOf(from: ConceptFlowLinkPoint, to: ConceptFlowLinkPoint): number {
  return round((from.x + to.x) / 2);
}

export function buildLinkPath(from: ConceptFlowLinkPoint, to: ConceptFlowLinkPoint): string {
  const start = roundPoint(from);
  const end = roundPoint(to);

  if (start.y === end.y) {
    return `M${start.x} ${start.y} L${end.x} ${end.y}`;
  }

  const bendX = bendOf(start, end);
  return `M${start.x} ${start.y} C${bendX} ${start.y} ${bendX} ${end.y} ${end.x} ${end.y}`;
}
